import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchDiscounts(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/discounts', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createDiscount(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/discounts/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        editDiscount(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/discounts/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchDiscount(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/discounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addDiscount(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/discounts`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteDiscount(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/discounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateDiscount(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/discounts/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}